module.exports = __webpack_public_path__ + "static/media/bitmLogo.439a3669.png";